// extracted by mini-css-extract-plugin
module.exports = {"container":"Section1_container__2Iten","wrapper":"Section1_wrapper__3n3gr"};